// extracted by mini-css-extract-plugin
export default {"orderListContainer":"style_orderListContainer__3wuke"};